module.exports = "<nv-react-component component=\"Scratchpad\"></nv-react-component>";